import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper";
import FormComponent from "../components/FormComponent";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./banner.css";
function Banner() {
    return (
        <>
            <section id="banner">
                <Swiper
                    modules={[EffectFade, Autoplay, Navigation, Pagination]}
                    effect="fade"
                    fadeEffect={{
                        crossFade: true,
                    }}
                    speed={1800}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    loop={true}
                >
                    <SwiperSlide>
                        <div className="bannerSection bannerSection1">
                            <div className="container-lg">
                                <div className="row ">
                                    <div className="col-lg-7 col-xl-8 position-relative">
                                        <div className="mobileWrap">
                                            <div className="bannerlist">
                                                <h1><span>Activate. Get rewarded.</span> <br />
                                                    Welcome benefits <br /> await.</h1>
                                                <h2 className="subtitle">
                                                    No joining fee & No annual fee<sup>#</sup>
                                                </h2>
                                            </div>
                                            <div className="bannerImg-wrap">
                                                <div className="bannerImg">
                                                    <img
                                                        src="dist/img/modal1.webp"
                                                        alt="model 1"
                                                        data-swiper-parallax="10%"
                                                        className="martm100"
                                                        width={335}
                                                        height={485}
                                                    />
                                                </div>
                                                <div className="cardImg">
                                                    <div className="bannerInfoBox marl35">
                                                        <h3>Activation Vouchers</h3>
                                                        <p>worth ₹2,700*/-</p>
                                                        <div className="iconWrap">
                                                            <img src="dist/img/icons-new/icon02.webp" alt="icon" width={37} height={37} />
                                                        </div>
                                                    </div>
                                                    <img src="dist/img/card_new_desk.webp" alt="cards" className="cards-desktop d-none d-md-block img-fluid" width={290} height={255} />
                                                    <img src="dist/img/card_new.webp" alt="cards" className="cards-mobile d-block d-md-none img-fluid" width={290} height={255} />
                                                    <div className="disclaimer">
                                                        <p>#Subject to eligibility.  *T&C apply.  <br class="d-block d-md-none" /> The image is AI generated.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="bannerSection bannerSection2">
                            <div className="container-lg">
                                <div className="row ">
                                    <div className="col-lg-7 col-xl-8 position-relative">
                                        <div className="mobileWrap">
                                            <div className="bannerlist">
                                                <h1><span>Lifestyle meets privilege.</span>  <br />
                                                    Your Apple upgrade <br />
                                                    starts here.</h1>
                                                <h2 className="subtitle">
                                                    No joining fee & No annual fee<sup>#</sup>
                                                </h2>
                                            </div>
                                            <div className="bannerImg-wrap">
                                                <div className="bannerImg">
                                                    <img
                                                        src="dist/img/modal2.webp"
                                                        alt="model 2"
                                                        data-swiper-parallax="10%"
                                                        width={335}
                                                        height={485}
                                                    />
                                                </div>
                                                <div className="cardImg">
                                                    <div className="bannerInfoBox even">
                                                        <h3>Instant cashback on Apple products</h3>
                                                        <div className="iconWrap">
                                                            <img src="dist/img/icons-new/icon03.webp" alt="icon" width={37} height={37} />
                                                        </div>
                                                    </div>
                                                    <img src="dist/img/card_new_desk.webp" alt="cards" className="cards-desktop d-none d-md-block img-fluid" width={290} height={255} />
                                                    <img src="dist/img/card_new.webp" alt="cards" className="cards-mobile d-block d-md-none img-fluid" width={290} height={255} />
                                                    <div className="disclaimer">
                                                        <p>#Subject to eligibility.  *T&C apply.  <br class="d-block d-md-none" /> The image is AI generated.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="bannerSection bannerSection3">
                            <div className="container-lg">
                                <div className="row ">
                                    <div className="col-lg-7 col-xl-8 position-relative">
                                        <div className="mobileWrap">
                                            <div className="bannerlist">
                                                <h1><span>Convenience meets control.</span> <br />
                                                    Take control of <br />
                                                    your credit card safety.</h1>
                                                <h2 className="subtitle">
                                                    No joining fee & No annual fee<sup>#</sup>
                                                </h2>
                                            </div>
                                            <div className="bannerImg-wrap">
                                                <div className="bannerImg">
                                                    <img
                                                        src="dist/img/modal3.webp"
                                                        alt="model 3"
                                                        data-swiper-parallax="10%"
                                                        width={335}
                                                        height={485}
                                                    />
                                                </div>
                                                <div className="cardImg">
                                                    <div className="bannerInfoBox">
                                                        <h3>Card Controls on iMobile</h3>
                                                        <div className="iconWrap">
                                                            <img src="dist/img/icons-new/icon04.webp" alt="icon" width={37} height={37} />
                                                        </div>
                                                    </div>
                                                    <img src="dist/img/card_new_desk.webp" alt="cards" className="cards-desktop d-none d-md-block img-fluid" width={290} height={255} />
                                                    <img src="dist/img/card_new.webp" alt="cards" className="cards-mobile d-block d-md-none img-fluid" width={290} height={255} />
                                                    <div className="disclaimer">
                                                        <p>#Subject to eligibility.  *T&C apply.  <br class="d-block d-md-none" /> The image is AI generated.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="bannerSection bannerSection4">
                            <div className="container-lg">
                                <div className="row ">
                                    <div className="col-lg-7 col-xl-8 position-relative">
                                        <div className="mobileWrap">
                                            <div className="bannerlist">
                                                <h1><span>Lights. Camera. Benefits. </span> <br />
                                                    Make your movie nights <br />
                                                    twice as special.</h1>
                                                <h2 className="subtitle">
                                                    No joining fee & No annual fee<sup>#</sup>
                                                </h2>
                                            </div>
                                            <div className="bannerImg-wrap">
                                                <div className="bannerImg">
                                                    <img
                                                        src="dist/img/modal4.webp"
                                                        alt="model 4"
                                                        data-swiper-parallax="10%"
                                                        width={335}
                                                        height={485}
                                                    />
                                                </div>
                                                <div className="cardImg">
                                                    <div className="bannerInfoBox even">
                                                        <h3 className="one-line">Buy One Get One offer**</h3>
                                                        <p className="one-line">on movie tickets up to ₹500</p>
                                                        <div className="iconWrap">
                                                            <img src="dist/img/icons-new/icon01.webp" alt="icon" width={37} height={37} />
                                                        </div>
                                                    </div>
                                                    <img src="dist/img/card_new_desk.webp" alt="cards" className="cards-desktop d-none d-md-block img-fluid" width={290} height={255} />
                                                    <img src="dist/img/card_new.webp" alt="cards" className="cards-mobile d-block d-md-none img-fluid" width={290} height={255} />
                                                    <div className="disclaimer">
                                                        <p>#Subject to eligibility.  *T&C apply.  **Basis minimum spends criteria. <br />
                                                            The image is AI generated.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>
                <div className="formWrap">
                    <div className="container-lg">
                        <div className="row">
                            <div className="col-lg-5 col-xl-4 px-3 offset-lg-7 offset-xl-8">
                                <FormComponent></FormComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
export default Banner;